import { useContext } from "react";
import { VirtualVisitContext } from "./context";


export function useVistualVisit() {
    const context = useContext(VirtualVisitContext)

    if (!context) {
        throw new Error('useVirtualVisit must be used within the VirtualVisitProvider');
    }

    return context;
}